import { createContext, useContext } from 'react';

interface GameContextType {
  score: number;
  setScore: (score: number) => void;
  balls: number;
  setBalls: (balls: number) => void;
  isDropped: boolean;
  setIsDropped: (isDropped: boolean) => void;
}

export const GameContext = createContext<GameContextType | undefined>(undefined);

export function useGame() {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
}
